import React, { useCallback, useContext, useEffect, useState } from "react";
import { Pressable, ScrollView, StyleSheet, View } from "react-native";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { PlaceColors } from "./helpers/PlaceColors";
import { PlaceText } from "./components/PlaceText";
import { IconShadow } from "./helpers/DefaultShadows";
import { FindifySimpleHeader } from "./components/FindifySimpleHeader";
import { BasePage } from "./helpers/BasePage";
import { FindifyTopBarOverlay } from "./components/FindifyTopBarOverlay";
import { makeContentDetails } from "./PlaceContentDetails";
import { FindifyLoadingScreen } from "./components/FindifyLoadingScreen";
import { BottomNavigationPadding } from "./components/FindifyNavigation";
import { ContentDetailsType, PlaceContentDetailsInitialUseEffect } from "./helpers/DetailsHelpers";
import { useTranslation } from "react-i18next";
import { getApiFromModule } from "./helpers/GetContentsByModule";
import { Dropdown } from "react-native-element-dropdown";
import { Controller, UseFormReturn, useForm } from "react-hook-form";
import { PublicShopCartApi } from "../../findifyv2-api-ts/public/store/ShopCartApi";
import uuid from 'react-native-uuid';

import Icon from "react-native-vector-icons/Ionicons";
import { FindifyToast } from "./components/FindifyToast";
import { FindifyBasicModal } from "./components/FindifyBasicModal";


export const loadTicketCollection = async (findifyDataContext: FindifyDataContextType, ticketCollectionId: number) => {
    const ticketCollection = await getApiFromModule('tickets_collections', findifyDataContext).get(ticketCollectionId, null, null);
    const ticketCollectionData = await loadDataFromTicketCollection(findifyDataContext, ticketCollectionId);
    return {
        ...ticketCollection,
        ...ticketCollectionData,
    }
}


export const loadDataFromTicketCollection = async (findifyDataContext: FindifyDataContextType, ticketCollectionId: number) => {
    const ticket_collections_tickets = await getApiFromModule('tickets_collections_tickets', findifyDataContext, ticketCollectionId).getList(0, 0, null, null, null);
    // Remove Duplicates
    const ticket_section_ids = Array.from(new Set(ticket_collections_tickets.results.map((tct: any) => tct.ticket_section_id).filter((id?: number) => id)));
    const ticket_type_ids = Array.from(new Set(ticket_collections_tickets.results.map((tct: any) => tct.ticket_type_id).filter((id?: number) => id)));
    const ticket_sections = await getApiFromModule('tickets_sections', findifyDataContext).getList(0, ticket_section_ids.length, null, {
        ticket_section_id_in: JSON.stringify(ticket_section_ids)
    }, null)
    const ticket_types = await getApiFromModule('tickets_types', findifyDataContext).getList(0, ticket_type_ids.length, null, {
        ticket_type_id_in: JSON.stringify(ticket_type_ids)
    }, null)

    let sections_seats: any = {};
    await Promise.all(ticket_sections.results.map((ts: any) => {
        return getApiFromModule('tickets_sections_seated', findifyDataContext, ts?.ticket_section_id)
            .getList(0, 0, null, {}, null)
            .then((ticket_sections_seated: any) => {
                sections_seats[ts?.ticket_section_id] = ticket_sections_seated.results;
            });
    }));



    // Add seats to sections
    const tickets = ticket_collections_tickets?.results?.map((tct: any) => {
        return {
            ...tct,
            ticket_type: ticket_types.results.find((tt: any) => tt.ticket_type_id === tct.ticket_type_id),
            ticket_section: ticket_sections.results?.find((ts: any) => ts.ticket_section_id === tct.ticket_section_id),
        };
    });

    const sections = ticket_sections.results?.map((section: any) => {
        return {
            ...section,
            seats: sections_seats[section.ticket_section_id],
            tickets: tickets.filter((tct: any) => tct.ticket_section_id === section.ticket_section_id),
        };
    });

    // Add  ticket type to collection tickets
    // Add  section to collection tickets
    return {
        tickets,
        ticketTypes: ticket_types.results,
        ticketSections: sections,
    };
}


export const EventTicketZone = ({ navigation, ...props }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [event, setEvent] = useState<any>({});
    const [contentSlug, setContentSlug] = useState<any>();
    const [contentModule, setContentModule] = useState<any>();
    const [currentTicketCollection, setCurrentTicketCollection] = useState<any>();
    const [currentTicketCollectionTickets, setCurrentTicketCollectionTickets] = useState<any>();
    const [ticketSections, setTicketSections] = useState<any>();
    const [ticketTypes, setTicketTypes] = useState<any>();
    const [hideDate, setHideDate] = useState(false);
    const [markedSeatModalOpen, setMarkedSeatModalOpen] = useState(false);
    const { t } = useTranslation();
    const [markedPlaceTickets, setMarkedPlaceTickets] = useState<any>({});
    const [ticketIncrementStyle, setTicketIncrementStyle] = useState<any>({});


    const shopCartApi = getApiFromModule('shop_cart', findifyDataContext) as PublicShopCartApi;
    const [onlineCart, setOnlineCart] = useState<any>(null);

    useEffect(() => {
        setTicketIncrementStyle({
            borderWidth: 1,
            borderColor: PlaceColors(findifyDataContext).text.solidAlphaWhiteBase(150),
            borderRadius: 40,
        })
    }, [findifyDataContext.darkMode]);

    const updateCart = useCallback(() => {
        shopCartApi.getList(0, 0, null, null, null).then((cart) => {
            setOnlineCart(cart.results);
        })
    }, [shopCartApi, setOnlineCart]);
    useEffect(() => {
        if (props.route.params && props.route.params.content) {
            setEvent(props.route.params.content);
            setCurrentTicketCollection(props.route.params.currentTicketCollection);
            setContentModule('events');
            // console.log('curentTicketCollection', props.route.params.currentTicketCollection)
        } else {
            PlaceContentDetailsInitialUseEffect(props, findifyDataContext, setEvent, setContentSlug, setContentModule, setHideDate);
        }
        updateCart();
    }, []);


    useEffect(() => {
        if (currentTicketCollection && !currentTicketCollectionTickets) {
            loadDataFromTicketCollection(findifyDataContext, currentTicketCollection?.ticket_collection_id).then((data) => {
                setCurrentTicketCollectionTickets(data.tickets);
                setTicketTypes(data.ticketTypes);
                setTicketSections(data.ticketSections);
            });

            // Load from cart
            console.log('loadstart', onlineCart, currentTicketCollection, currentTicketCollection?.ticket_collection_id)
        }
    }, [currentTicketCollection]);


    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        {event &&
            <ScrollView
                bounces={false}
                showsHorizontalScrollIndicator={false}
                showsVerticalScrollIndicator={false}
                style={[styles.container, { backgroundColor: PlaceColors(findifyDataContext).background.get() }]}>
                {makeContentDetails(MakeContentDetailsPage, event, t, false, contentModule, navigation, findifyDataContext)}
                <View style={{ marginTop: 0, margin: 10 }}>
                    <PlaceText
                        style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: PlaceColors(findifyDataContext).text.get(),
                        }}
                    >{currentTicketCollection?.name}</PlaceText>
                    <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontSize: 16 }}>
                        {currentTicketCollection?.description}
                    </PlaceText>
                </View>
                {
                    ticketSections?.map((section: any) => {

                        return <View key={'container_section_' + section?.ticket_section_id}>
                            <View
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // justifyContent: 'space-between',
                                    // alignItems: 'center',
                                    backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
                                    margin: 10,
                                    padding: 10,
                                    borderRadius: 10
                                }}
                            >
                                <Pressable
                                    style={{
                                        // backgroundColor: 'orange',
                                    }}
                                    onPress={() => {
                                        section.expanded = !section.expanded ?? true;
                                        setCurrentTicketCollectionTickets([...currentTicketCollectionTickets]);
                                    }}
                                >
                                    <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontWeight: 'bold' }}>{section?.section_name}</PlaceText>
                                    <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontSize: 12 }}>{section?.description}</PlaceText>
                                </Pressable>
                                {/* {section.expanded && <View */}
                                {section.expanded && <View
                                    style={{
                                        display: 'flex',
                                        flexDirection: section.has_seated_places ? 'column' : 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        gap: 10,
                                    }}
                                >
                                    {/* // Multiple Tickets in session means that there are multiple types in it */}
                                    {/* // IF Seats are marked, User selects ROW/PLACE and type */}
                                    {section.has_seated_places &&
                                        <View key={`section_${section.ticket_section_id}`}>
                                            <View style={{ display: 'flex', flexDirection: 'row', marginTop: 10, paddingRight: 20, alignItems: 'center', width: '100%' }}>
                                                <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), flex: 1 }}>{t('base.tickets.row')}</PlaceText>
                                                <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), flex: 1 }}>{t('base.tickets.seat')}</PlaceText>
                                                <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), flex: 1 }}>{t('base.tickets.type')}</PlaceText>
                                                <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), flex: 1 }}>{t('base.tickets.price')}</PlaceText>
                                            </View>
                                            {section?.tickets?.map((ticket: any) => {
                                                const currentCartItems = onlineCart?.filter((cartItem: any) => cartItem.shop_item_id === ticket.shop_item_id);

                                                return <>
                                                    {currentCartItems?.map((ticket_line: any, index: number) => {
                                                        return <View
                                                            key={`${section.ticket_section_id}.${index}`}
                                                            style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center' }}>
                                                            <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), paddingVertical: 5, flex: 1 }}>{ticket_line.seated_row}</PlaceText>
                                                            <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), paddingVertical: 5, flex: 1 }}>{ticket_line.seated_column}</PlaceText>
                                                            <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), paddingVertical: 5, flex: 1 }}>{section?.tickets?.find((t: any) => t.ticket_type_id === ticket_line?.shop_item?.ticket_collection_ticket[0]?.ticket_type_id)?.ticket_type.name}</PlaceText>
                                                            <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), paddingVertical: 5, flex: 1 }}>{ticket_line.price}</PlaceText>
                                                            <Icon
                                                                name={"trash-outline"}
                                                                size={20}
                                                                color={PlaceColors(findifyDataContext).text.get()}
                                                                onPress={() => {
                                                                    shopCartApi.delete(ticket_line.cart_item_id, null, null).then((cart) => {
                                                                        // MAKE A SUCCESS TOAST
                                                                        FindifyToast({
                                                                            id: uuid.v4(),
                                                                            visibilityTime: 1500,
                                                                            type: 'success',
                                                                            message: t('checkout.cart_updated_successfully'),
                                                                        })
                                                                        // UPDATE THE USER CART
                                                                        updateCart();
                                                                    }).catch((err: any) => {
                                                                        // MAKE A ERROR TOAST
                                                                        FindifyToast({
                                                                            id: uuid.v4(),
                                                                            visibilityTime: 1500,
                                                                            type: 'error',
                                                                            message: t('checkout.error_updating_cart'),
                                                                        })
                                                                    });
                                                                }}
                                                            />
                                                        </View>
                                                    })}
                                                </>
                                            })}
                                            <Pressable
                                                style={{
                                                    borderWidth: 1,
                                                    borderColor: PlaceColors(findifyDataContext).text.get(),
                                                    borderRadius: 10,
                                                    padding: 6,
                                                    alignSelf: 'center',
                                                    marginTop: 10,
                                                }}
                                                onPress={() => {
                                                    setMarkedSeatModalOpen(!markedSeatModalOpen);
                                                }}
                                            ><PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{t('base.tickets.add_ticket')}</PlaceText></Pressable>
                                            <MakeMarkedSeatModal
                                                section={section}
                                                updateCart={updateCart}
                                                shopCartApi={shopCartApi}
                                                findifyDataContext={findifyDataContext}
                                                markedSeatModalOpen={markedSeatModalOpen}
                                                setMarkedSeatModalOpen={setMarkedSeatModalOpen} />
                                        </View>
                                    }
                                    {!section.has_seated_places &&
                                        <Pressable
                                            style={{
                                                // backgroundColor: 'red',
                                                gap: 10,
                                                paddingTop: 10,
                                                flex: 1
                                            }}
                                            onPress={() => { }}>

                                            {section?.tickets?.map((ticket: any) => {
                                                const currentCartItem = onlineCart?.find((cartItem: any) => cartItem.shop_item_id === ticket.shop_item_id);
                                                return <View
                                                    style={{
                                                        flexDirection: 'row',
                                                        alignContent: 'center',
                                                        flex: 1,
                                                    }}
                                                >
                                                    <View style={{ flex: 1 }}  >
                                                        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontWeight: 'bold' }}>{ticket.ticket_type.name}</PlaceText>
                                                        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontSize: 12 }}>{ticket.ticket_type.description}</PlaceText>
                                                    </View>
                                                    <View
                                                        style={{
                                                            flex: 1,
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            gap: 4
                                                        }}
                                                    >
                                                        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), }}>{removeTrailingZeros(ticket.ticket_type.default_price)} €</PlaceText>
                                                    </View>
                                                    <View
                                                        style={{
                                                            height: 31,
                                                            // flex: 1,
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            gap: 4,
                                                            padding: 0,
                                                            ...ticketIncrementStyle,
                                                        }}
                                                    >
                                                        <View
                                                            style={{
                                                                opacity: (currentCartItem?.quantity ?? 0) > 0 ? 1 : 0.2,
                                                                backgroundColor: (currentCartItem?.quantity ?? 0) > 0 ? PlaceColors(findifyDataContext).background.get() : PlaceColors(findifyDataContext).text.solidAlphaWhiteBase(200),
                                                                ...ticketIncrementStyle,
                                                                padding: 4,
                                                                margin: -1
                                                            }}
                                                        >
                                                            <Icon
                                                                name="remove-outline"
                                                                size={20}
                                                                color={PlaceColors(findifyDataContext).text.get()}
                                                                onPress={() => changeSimpleTicketCount(t, shopCartApi, currentCartItem, ticket, updateCart, false)}
                                                            />
                                                        </View>
                                                        <PlaceText style={{
                                                            fontSize: 20,

                                                            padding: 0,
                                                            margin: 0,
                                                            color: PlaceColors(findifyDataContext).text.get(),
                                                        }} > {currentCartItem?.quantity ?? 0}</PlaceText >

                                                        <View
                                                            style={{
                                                                backgroundColor: PlaceColors(findifyDataContext).background.get(),
                                                                ...ticketIncrementStyle,
                                                                padding: 4,
                                                                margin: -1
                                                            }}
                                                        >
                                                            <Icon
                                                                name="add-outline"
                                                                size={20}
                                                                color={PlaceColors(findifyDataContext).text.get()}
                                                                style={{}}
                                                                onPress={() => changeSimpleTicketCount(t, shopCartApi, currentCartItem, ticket, updateCart, true)}
                                                            />
                                                        </View>
                                                    </View>
                                                </View>
                                            })}
                                        </Pressable>
                                    }
                                </View>
                                }
                            </View>
                        </View>
                    })
                }

                <Pressable
                    style={{
                        // borderWidth: 1,
                        backgroundColor: PlaceColors(findifyDataContext).text.get(),
                        // borderColor: PlaceColors(findifyDataContext).text.get(),
                        borderRadius: 10,
                        padding: 10,
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: 10,

                    }}
                    onPress={() => {
                        navigation.push('CheckoutPage');
                    }}
                >
                    <PlaceText style={{ color: PlaceColors(findifyDataContext).alternateListBG.get() }}>{t('base.tickets.checkout')}</PlaceText>
                </Pressable>

            </ScrollView>
        }
        {!event && <FindifyLoadingScreen />}

    </BasePage >;
}

function removeTrailingZeros(inputString: string) {
    // Use a regular expression to remove trailing zeros
    const stringWithNoTrailingZeros = inputString.replace(/(\.0+|(?<=\.\d+?)0+)$/, '');
    return stringWithNoTrailingZeros;
}

const makeTicketDropdown = (findifyDataContext: any, t: any, form: UseFormReturn, fieldKey: string, label: string, data: any[], labelField: string, valueField: string) => {
    const isDarkmodeEnabled = findifyDataContext?.darkMode;

    return <Controller
        key={fieldKey}
        name={fieldKey}
        control={form.control}
        rules={{ required: true }}
        render={({ field }) => {
            return <>
                <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }} >{label}</PlaceText>
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        borderWidth: 1,
                        borderRadius: 10,
                        paddingVertical: 3,
                    }}>
                    <Dropdown
                        placeholder={t('base.form.select_option')}
                        style={{ flex: 1, ...(isDarkmodeEnabled ? { borderWidth: 1, borderColor: PlaceColors(findifyDataContext).text.get(), borderRadius: 5 } : {}) }}
                        placeholderStyle={{ color: PlaceColors(findifyDataContext).text.get(), padding: 5 }}
                        iconColor={PlaceColors(findifyDataContext).text.get()}
                        containerStyle={{ backgroundColor: PlaceColors(findifyDataContext).background.get(), borderRadius: 5 }}
                        itemTextStyle={{ color: PlaceColors(findifyDataContext).text.get(), padding: 0, margin: 0 }}
                        selectedTextStyle={{ color: PlaceColors(findifyDataContext).text.get(), padding: 5 }}
                        data={data}
                        activeColor={PlaceColors(findifyDataContext).text.withAlpha(140)}
                        value={form.getValues(field.name)}
                        labelField={labelField}
                        valueField={valueField}
                        onChange={item => {
                            if (item[valueField] === form.getValues(field.name)) {
                                form.setValue(field.name, null);
                            } else {
                                form.setValue(field.name, item[valueField]);
                            }
                        }}
                    />
                </View>
            </>

        }}
    />

}


const MakeMarkedSeatModal = ({
    findifyDataContext,
    markedSeatModalOpen,
    setMarkedSeatModalOpen,
    section,
    shopCartApi,
    updateCart,
}: {
    findifyDataContext: FindifyDataContextType | null,
    markedSeatModalOpen: boolean,
    setMarkedSeatModalOpen: Function,
    section: any,
    shopCartApi: PublicShopCartApi,
    updateCart: Function,
}) => {
    const form = useForm({});
    const [rowsOptions, setRowsOptions] = useState([]);
    const [typesOptions, setTypesOptions] = useState([])
    const { t } = useTranslation();
    useEffect(() => {
        setRowsOptions(makeSectionRowsOptions(section));
        setTypesOptions(makeSectionTypesOptions(section));
    }, [])

    return <>
        <FindifyBasicModal
            isOpen={markedSeatModalOpen}
            closeModal={() => {
                setMarkedSeatModalOpen(false)
            }}
        >
            <View style={{
                backgroundColor: PlaceColors(findifyDataContext).background.get(),
                borderRadius: 10,
                padding: 15,
                overflow: 'hidden',
                gap: 10,
                // borderColor: 'pink'
            }}>
                <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{t('checkout.select_your_ticket')}</PlaceText>
                {makeTicketDropdown(findifyDataContext, t, form, 'ticket_type_id', t('checkout.ticket_type'), typesOptions, 'label', 'value')}
                {makeTicketDropdown(findifyDataContext, t, form, 'seated_row', t('checkout.row'), rowsOptions, 'label', 'value')}
                <Controller
                    key={'seated_row_pre_seats'}
                    name={'seated_row'}
                    control={form.control}
                    render={({ field }) => {
                        return makeTicketDropdown(findifyDataContext, t, form, 'seated_column', t('checkout.seat'), makeSectionSeatsOptions(section, field.value), 'label', 'value');
                    }}
                />
                <Pressable
                    style={{
                        borderWidth: 1,
                        borderColor: PlaceColors(findifyDataContext).text.get(),
                        borderRadius: 10,
                        padding: 6,
                        alignSelf: 'center',
                        marginTop: 10,
                    }}
                    onPress={async () => {
                        const validForm = await form.trigger();
                        if (validForm) {
                            const values = form.getValues()
                            const ticket = section.tickets.find((t: any) => t.ticket_type_id === values.ticket_type_id);

                            shopCartApi.create({
                                "shop_item_id": ticket.shop_item_id,
                                "quantity": 1,
                                "price": ticket.price,
                                ...values,
                            }, null).then((newCart: any) => {
                                // MAKE A SUCCESS TOAST
                                FindifyToast({
                                    id: uuid.v4(),
                                    visibilityTime: 1500,
                                    type: 'success',
                                    message: t('checkout.cart_updated_successfully'),
                                })
                                // UPDATE THE USER CART
                                setMarkedSeatModalOpen(false);
                                updateCart();
                            }).catch((err: any) => {
                                // MAKE A ERROR TOAST
                                FindifyToast({
                                    id: uuid.v4(),
                                    visibilityTime: 1500,
                                    type: 'error',
                                    message: t('checkout.error_updating_cart'),
                                })
                            })

                        }
                    }}
                >
                    <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>
                        {t('base.tickets.add_ticket')}
                    </PlaceText>
                </Pressable>
            </View>
        </FindifyBasicModal>
    </>
}


const changeSimpleTicketCount = (t: any, shopCartApi: PublicShopCartApi, currentCartItem: any, ticket: any, updateCart: Function, increment: boolean) => {
    const newQuantity = (currentCartItem?.quantity ?? 0) + (increment ? 1 : -1);

    if (newQuantity === 0) {
        shopCartApi.delete(currentCartItem.cart_item_id, null).then((upd: any) => {
            // MAKE A SUCCESS TOAST
            FindifyToast({
                id: uuid.v4(),
                visibilityTime: 1500,
                type: 'success',
                message: t('checkout.cart_updated_successfully'),
            })
            // UPDATE THE USER CART
            updateCart();
        }).catch((err: any) => {
            // MAKE A ERROR TOAST
            FindifyToast({
                id: uuid.v4(),
                visibilityTime: 1500,
                type: 'error',
                message: t('checkout.error_updating_cart'),
            })
        })
    } else if (newQuantity > 0) {
        shopCartApi.create({
            "shop_item_id": ticket.shop_item_id,
            "quantity": newQuantity,
            "price": ticket.price
        }, null).then((upd: any) => {
            // MAKE A SUCCESS TOAST
            FindifyToast({
                id: uuid.v4(),
                visibilityTime: 1500,
                type: 'success',
                message: t('checkout.cart_updated_successfully'),
            })
            // UPDATE THE USER CART
            updateCart();
        }).catch((err: any) => {
            // MAKE A ERROR TOAST
            FindifyToast({
                id: uuid.v4(),
                visibilityTime: 1500,
                type: 'error',
                message: t('checkout.error_updating_cart'),
            })
        })
    }
}

const makeSectionRowsOptions = (section: any): any[] => {
    return section?.seats?.map((line: any) => { return { label: line?.row?.toUpperCase(), value: line?.row?.toUpperCase() } }) ?? [];
}

const makeSectionSeatsOptions = (section: any, row: any): any[] => {
    const seats = section.seats.find((s: any) => s?.row?.toUpperCase() === row?.toUpperCase());
    return Array.from({ length: seats?.number_of_seats }, (_, index) => { return { label: (index + 1).toString(), value: index + 1 } }) ?? []
}

const makeSectionTypesOptions = (section: any): any[] => {
    return section?.tickets?.map((ticket: any) => { return { label: ticket.ticket_type.name, value: ticket.ticket_type.ticket_type_id } }) ?? [];
}

const MakeContentDetailsPage = ({ image, title, navigation, resume, description, dateString, rightActions, content, t, hideDate, module, findifyDataContext }: ContentDetailsType) => {
    const topTextStyle = {
        marginTop: 5,
        fontSize: 14,
        color: PlaceColors(findifyDataContext).text.withAlpha(160)
    };


    return <>
        <FindifySimpleHeader
            navigation={navigation}
            title={title}
            // actions={actionsList}
            image={image} />
        <View style={styles.text}>
            <View style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}>
                <View>
                    {!hideDate
                        &&
                        <PlaceText style={{
                            marginTop: 5,
                            marginBottom: 10,
                            fontSize: 14,
                            color: PlaceColors(findifyDataContext).text.withAlpha(200)
                        }}>{dateString}</PlaceText>
                    }
                </View>
            </View>
        </View >
    </>
}

const styles = StyleSheet.create({
    text: {
        padding: 10,
        paddingBottom: 10 + BottomNavigationPadding,
    },
    container: {
        height: '100%',
        width: '100%',
    },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
